import { Component } from '@angular/core';
import { WordpressService } from '../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../services/http/wordpress/wordpress.interface';
import { CommonModule } from '@angular/common';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-accesible',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './accesible.component.html',
  styleUrl: './accesible.component.scss'
})
export class AccesibleComponent {
  title = "";
  description = "";
  image = "";

  accesibleText = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({ client: WpClientCode.genCat, section: WpSectionCode.accesible }).subscribe((data) => {
      if (data) {
        this.accesibleText = data.content.rendered;
        this.title = data.title.rendered;
        this.image = data.acf.image_url;
      }
    });
  }
}
